import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import {
  EventDate,
  OneDayMembership,
  ProductVariant,
  Profile,
  SkillSummary,
} from 'src/app/core/models';

@Component({
  selector: 'app-one-day-license-menu-accordion',
  templateUrl: './one-day-license-menu-accordion.component.html',
  styleUrls: ['./one-day-license-menu-accordion.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OneDayLicenseMenuAccordionComponent implements OnInit {
  @Input() user: Profile;
  @Input() eventDate: EventDate;
  @Input() dayNumber: number;
  @Input() skillSummary: SkillSummary;
  @Input() purchasedOneDays: OneDayMembership[];
  @Input() licenseVariants: ProductVariant[];

  @Output() formChange: EventEmitter<any> = new EventEmitter(null);

  toggleIcon = 'icon-chevron-down';

  licenseForm: FormGroup;

  get f(): any {
    return this.licenseForm.controls;
  }

  get previouslyPurchased(): boolean {
    return this.purchasedOneDays.some(
      (oneDay) => oneDay.event_date_id === this.eventDate.event_date_id
    );
  }

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    if (!this.previouslyPurchased) {
      this.createForm();
      this.subscribeToForm();
    }
  }

  createForm(): void {
    const controls = {};
    this.licenseVariants.forEach((variant) => {
      let disabled = false;
      if (this.licenseVariants.length > 1) {
        disabled =
          (this.skillSummary.is_experienced && variant.sku.includes('1DAY-B-')) ||
          (this.skillSummary.is_beginner && variant.sku.includes('1DAY-E-'));
      }
      controls[`${this.eventDate.event_date_id}_${variant.sku}`] = {
        value: false,
        disabled,
      };
    });
    this.licenseForm = this.fb.group(controls);
  }

  subscribeToForm(): void {
    this.licenseForm.valueChanges.subscribe((val) => this.formChange.emit(val));
  }

  onPanelChange(event: any): void {
    this.toggleIcon = event.nextState ? 'icon-chevron-up' : 'icon-chevron-down';
  }

  variantControl(variant: ProductVariant): FormControl {
    return this.f[`${this.eventDate.event_date_id}_${variant.sku}`];
  }

  optionDisabled(variant: ProductVariant): boolean {
    return this.variantControl(variant).disabled;
  }

  toggleControlValue(variant: ProductVariant): void {
    const control = this.variantControl(variant);
    if (control) {
      control.setValue(!control.value);
    }
  }

  btnClass(variant: ProductVariant): string {
    return !!this.variantControl(variant).value ? 'btn-primary' : 'btn-secondary';
  }

  btnText(variant: ProductVariant): string {
    return !!this.variantControl(variant).value ? 'Remove' : 'Add to Cart';
  }
}
